import {
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { useEffect } from 'react'
import 'react-credit-cards/es/styles-compiled.css'
import { AiOutlineCheck, AiOutlineRight } from 'react-icons/ai'
import UBox from 'src/components/ui/Ubox'
import usePagamento from 'src/hooks/usePagamento'

const useStyles = makeStyles(theme => ({
  root: {
    border: '0',
    background: '#fff',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '10px 16px',
    borderBottom: '1px solid #efefef'
  },
  step: {
    color: theme.palette.primary.main,
    lineHeight: '1',
    background: 'transparent',
    padding: '8px',
    borderRadius: '12px',
    opacity: '0.5',
    '&.active': {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
      background: '#f3f3f3',
      padding: '8px',
      borderRadius: '12px',
      opacity: '1'
    },
    '& .icon': {
      width: '24px',
      height: '24px',
      minWidth: '24px',
      minHeight: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      fontWeight: 600,
      background: '#CBD5E1'
    },
    '& .title': {
      fontWeight: 600
    },
    '&.done': {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
      opacity: '1',
      cursor: 'pointer',
      '& .icon': {
        border: `1px solid ${theme.palette.secondary.main}`,
        color: theme.palette.secondary.main,
        background: 'transparent'
      },
      '&.active': {
        opacity: '1'
      }
    }
  }
}))

export interface IStepItem {
  titulo: string
  status: string
}

interface IProps {
  opcaoVoltarMostrarComoFunciona: boolean
  handleVoltarMostrarComoFunciona: () => void
  activeStep: number
  handleStep1: () => void
  steps?: (string | IStepItem)[]
  onStepClick?: (stepIndex: number) => void
}

function getStepLabel(step: string | IStepItem): string {
  return typeof step === 'string' ? step : step.titulo
}

function getStepStatus(step: string | IStepItem): string | null {
  return typeof step === 'string' ? null : step.status
}

export default function Steps({
  opcaoVoltarMostrarComoFunciona,
  handleVoltarMostrarComoFunciona,
  activeStep,
  handleStep1,
  steps = ['Dados pessoais NF', 'Pagamento'],
  onStepClick
}: IProps) {
  const classes = useStyles()
  const theme = useTheme()
  const ehXS = useMediaQuery(theme.breakpoints.down('sm'))

  const { resumo } = usePagamento()

  useEffect(() => {}, [])

  if (!resumo) return <></>

  const handleStepClick = (stepIndex: number) => {
    if (stepIndex === 0 && activeStep > 0) {
      handleStep1()
    } else if (onStepClick && stepIndex < activeStep) {
      onStepClick(stepIndex)
    }
  }

  if (ehXS) {
    const total = steps.length
    const atual = Math.min(activeStep + 1, total)

    return (
      <UBox className={classes.root}>
        <UBox display="flex" alignItems="center" justifyContent="space-between">
          <span style={{ fontWeight: 600 }}>
            {`Etapa ${atual} de ${total}`}
          </span>
          {(activeStep > 0 ||
            (activeStep === 0 && opcaoVoltarMostrarComoFunciona)) && (
            <Typography
              style={{
                fontWeight: 600,
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
              color="primary"
              onClick={() => {
                if (activeStep > 0) {
                  handleStepClick(activeStep - 1)
                } else {
                  handleVoltarMostrarComoFunciona()
                }
              }}
            >
              voltar
            </Typography>
          )}
        </UBox>
      </UBox>
    )
  }

  return (
    <UBox className={classes.root}>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {steps.map((step, index) => {
          let label = getStepLabel(step)
          const status = getStepStatus(step)

          const ehCompleto = status === 'Pago'
          const isDone = activeStep > index || ehCompleto
          const isActive = activeStep === index
          const isClickable = isDone || activeStep > index
          if (steps.length > 3 && !isActive) {
            label = isDone ? label : '...'
            if (isDone && activeStep - index > 1) {
              label = '...'
            }
          }

          return (
            <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
              <UBox
                className={`${classes.step} ${isActive ? 'active' : ''} ${
                  isDone ? 'done' : ''
                }`}
                display="flex"
                alignItems="center"
                onClick={() => isClickable && handleStepClick(index)}
                style={{
                  cursor: isClickable ? 'pointer' : 'default',
                  minHeight: '38px'
                }}
              >
                {!(index === 0 && !isDone) && (
                  <span className="icon">
                    {index > 0 || isDone ? (
                      isDone ? (
                        <AiOutlineCheck />
                      ) : (
                        index
                      )
                    ) : (
                      ''
                    )}
                  </span>
                )}
                <UBox className="title" component="span" ml={1}>
                  {label}
                </UBox>
              </UBox>
              {index < steps.length - 1 && (
                <UBox mx={2} style={{ display: 'flex', alignItems: 'center' }}>
                  <AiOutlineRight />
                </UBox>
              )}
            </div>
          )
        })}
      </div>
    </UBox>
  )
}
